import * as React from "react";

function SvgSync(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 14.5C32 22.3408 25.7766 28.728 18 28.9915V24.9883C23.5668 24.7273 28 20.1314 28 14.5C28 8.70101 23.299 4 17.5 4C11.8686 4 7.2727 8.43318 7.01172 14H10L5 22L0 14H3.00848C3.27201 6.22339 9.65924 0 17.5 0C25.5082 0 32 6.49187 32 14.5Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgSync;
